<div class="sp-properties-main">
    <div class="sp-table-row">
        <div class="main"><router-outlet></router-outlet></div>
    </div>
</div>
